export function replaceDynamicConstantByObject(constant: string | undefined, objectOfValues: { [key: string]: string }) {
  const cmsValue = constant || '';

  return Object.keys(objectOfValues).reduce((result, key) => {
    const regex = new RegExp(`{{\\s?${key}\\s?}}`, 'g');
    const value = objectOfValues[key];

    return result.replace(regex, value);
  }, cmsValue);
}
